import { c as _c } from "react/compiler-runtime";
import type { InferGetStaticPropsType, NextPage } from "next";
import { useState } from "react";
import { HomeLandingFaq } from "#/features/homePage/ui/landing/HomeLandingFaq";
import { HomeLandingHero } from "#/features/homePage/ui/landing/HomeLandingHero";
import { HomeLandingSections } from "#/features/homePage/ui/landing/HomeLandingSections";
import { getI18nPropsWithCanonical } from "#/i18n/getI18nProps";
import { useI18nContext } from "#/shared/hooks";
import { SiteSeoHead } from "#/shared/ui/seo/SiteSeoHead";
import { MainLayout } from "#/shared/ui/templates/MainLayout";
export const getStaticProps = getI18nPropsWithCanonical("/");
type DashboardProps = InferGetStaticPropsType<typeof getStaticProps>;
const DashboardPage: NextPage<DashboardProps> = t0 => {
  const $ = _c(13);
  const {
    canonicalUrl
  } = t0;
  const {
    LL
  } = useI18nContext();
  const [pageScrollViewport, setPageScrollViewport] = useState(null);
  let t1;
  if ($[0] !== canonicalUrl) {
    t1 = <SiteSeoHead title={"dStruct \u2014 visualize LeetCode solutions"} canonicalUrl={canonicalUrl} />;
    $[0] = canonicalUrl;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== LL || $[3] !== pageScrollViewport) {
    t2 = <HomeLandingHero LL={LL} pageScrollViewport={pageScrollViewport} />;
    $[2] = LL;
    $[3] = pageScrollViewport;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  let t4;
  if ($[5] !== LL) {
    t3 = <HomeLandingSections LL={LL} />;
    t4 = <HomeLandingFaq LL={LL} />;
    $[5] = LL;
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
    t5 = <MainLayout headerPosition="fixed" pageScrollViewportRef={setPageScrollViewport}>{t1}{t2}{t3}{t4}</MainLayout>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};
export default DashboardPage;